export const INDEX = 5;
export const CLIENTS = [
    { index: 1, appId: 'com.house.peony', appName: 'Sparkalz',identifier: 'silverfox' },
    { index: 2, appId: 'com.owner.peony', appName: 'House of Peony',identifier: 'houseofpeony' },
    { index: 3, appId: 'com.myhomekwt', appName: 'Silent Spa',identifier: 'silentspa' },
    { index: 4, appId: 'fit.dietmaster.healthychoices', appName: 'Pointy Nails',identifier: 'pointynailspa' },
    { index: 5, appId: 'com.anfaskw', appName: 'Salt Cave Spa',identifier: 'saltcavespa' },

    // { index: 3, appId: 'com.sto', appName: 'STO',identifier: 'sto' },com.anfaskw
]
